import { z } from 'zod';

export const PlanCodeZod = z.union([
    z.literal('simple_will_single'),
    z.literal('simple_will_couple'),
    z.literal('custom_will_single'),
    z.literal('custom_will_couple'),
    z.literal('living_trust_single'),
    z.literal('living_trust_couple'),
]);

export type PlanCode = z.infer<typeof PlanCodeZod>;
